(function () {
  angular.module('MktzapApp.Factories')
    .factory('HsmCrudService', HsmCrudService);

  HsmCrudService.$inject = ['$resource'];

  function HsmCrudService ($resource) {
    return $resource(apiUrl + '/channels-plugin/hsm/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      paged: { url: apiUrl + '/channels-plugin/hsm/list', method: 'GET', params: {}, isArray: false },
      find: { method: 'GET', params: {}, isArray: true },
      findOne: { method: 'GET', params: {}, isArray: false },
      getHsmLanguage: { url: apiUrl + '/channels-plugin/hsm/language', method: 'GET', params: {}, isArray: false }
    });
  }
})();
